var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"gutter":16}},_vm._l((_vm.cards),function(item){return _c('el-col',{key:item.label,attrs:{"span":6}},[_c('el-card',[_c('div',[_vm._v(_vm._s(item.label))]),_c('h2',[_vm._v(_vm._s(item.value))])])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }